import { render } from "./samedate.vue?vue&type=template&id=7904a58d"
import script from "./samedate.vue?vue&type=script&lang=js"
export * from "./samedate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__